import*as o from"react";import{portalLight as r}from"./portal.css";export{r as portalLight};
